// One vocabulary for "what kind of organization is this account": Accounts (Beta), Client segments and the
// Pricing Engine all read clients.type through these helpers, so a county is a county on every screen.
export const ENTITY_KINDS = [
	{ key: 'municipality', label: 'Municipality' },
	{ key: 'county', label: 'County' },
	{ key: 'district', label: 'District' },
	{ key: 'business', label: 'Business' },
	{ key: 'nonprofit', label: 'Nonprofit & Org' },
	{ key: 'fire', label: 'Fire Department' },
	{ key: 'police', label: 'Police Department' },
	{ key: 'personal', label: 'Personal' },
	{ key: 'other', label: 'Other' },
]

// The raw values clients.type has carried over the years, folded to the kinds above.
const RAW = {
	municipality: ['municipality', 'city', 'town', 'township', 'village', 'borough'],
	county: ['county'],
	district: ['district', 'lake district'],
	business: ['business'],
	nonprofit: ['organization', 'non profit', 'association', 'chamber', 'united way'],
	fire: ['fire department'],
	police: ['police department'],
	personal: ['personal'],
	other: ['other'],
}

/** Label of a kind key ("county" → "County"); an unknown key comes back as is. */
export function entityLabel(key) {
	const e = ENTITY_KINDS.find(x => x.key === key)
	return e ? e.label : key
}

/** Kind key for a raw clients.type value, or null when it matches none. */
export function entityKind(type) {
	const t = String(type || '').toLowerCase().trim()
	for (const key in RAW) {
		if (RAW[key].includes(t)) return key
	}
	return null
}

/** Label for a raw clients.type value; falls back to the raw text, then a dash. */
export function entityLabelFor(type) {
	const k = entityKind(type)
	return k ? entityLabel(k) : type || '—'
}
